import React from 'react';
import { CountdownTimer } from './CountdownTimer';
const offer = {
  emoji: '🏆',
  title: 'BASKET PRONTO + KIT TATTICO PRO',
  description: '6 Volumi + 6 Bonus + Kit Tattico Pro',
  originalPrice: '€67',
  price: '19',
  currency: '€',
  ctaText: '🚀 VOGLIO BASKET PRONTO ORA',
  ctaHref: 'https://docentes2.edulabs.online/cart/43273433809014:1',
  savings: 'RISPARMI €48'
};
const includes = ['6 Volumi Completi', '6 Bonus Strategici', 'Kit Tattico Pro', 'Oltre 150 Allenamenti', '101 Esercizi Professionali', 'Accesso a vita'];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-white py-16 sm:py-24 px-4" data-id="element-137">
      <div className="max-w-xl mx-auto" data-id="element-138">
        <div className="text-center mb-10" data-id="element-139">
          <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] mb-3 tracking-tight" data-id="element-140">
            Tutto incluso,{' '}
            <span className="text-[#FF6B00]" data-id="element-141">un solo prezzo.</span>
          </h2>
          <p className="text-[#5A5A66] text-sm sm:text-base font-bold" data-id="element-142">
            Pacchetto completo. Niente upsell. Niente sorprese.
          </p>
        </div>

        <div className="relative bg-white border-2 border-[#FF6B00] rounded-3xl pt-10 px-6 sm:px-10 pb-8 sm:pb-10 shadow-xl mb-6 text-center" data-id="element-143">
          {/* Centered top ribbon */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#FF6B00] text-white text-[10px] sm:text-xs font-black px-5 py-2 rounded-full uppercase tracking-widest shadow-lg whitespace-nowrap" data-id="element-144">
            🏆 PACCHETTO COMPLETO
          </div>

          {/* Title */}
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-145">
            <span className="text-2xl sm:text-3xl" data-id="element-146">{offer.emoji}</span>
            <span className="text-[#0A0A0A] font-black text-lg sm:text-2xl tracking-tight" data-id="element-147">
              {offer.title}
            </span>
          </div>
          <p className="text-[#5A5A66] text-sm sm:text-base font-semibold mb-7" data-id="element-148">
            {offer.description}
          </p>

          {/* Price block — centered */}
          <div className="mb-7 pb-7 border-b border-[#E5E5EA]" data-id="element-149">
            <div className="text-[#5A5A66] line-through text-base font-bold mb-2" data-id="element-150">
              Prezzo originale: {offer.originalPrice}
            </div>
            <div className="flex items-start justify-center gap-1 mb-3" data-id="element-151">
              <span className="font-black text-3xl sm:text-4xl text-[#0A0A0A] mt-2 sm:mt-3" data-id="element-152">
                {offer.currency}
              </span>
              <span className="font-black text-7xl sm:text-8xl text-[#0A0A0A] tracking-tighter leading-none" data-id="element-153">
                {offer.price}
              </span>
            </div>
            <span className="inline-block bg-[#00C853] text-white text-xs font-black px-4 py-2 rounded-full uppercase tracking-widest shadow-md" data-id="element-154">
              {offer.savings}
            </span>
          </div>

          {/* Includes label */}
          <p className="text-[#0A0A0A] text-xs font-black uppercase tracking-widest mb-5" data-id="element-155">
            Cosa è incluso
          </p>

          {/* Includes grid — centered */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 max-w-md mx-auto text-left" data-id="element-156">
            {includes.map(item => <div key={item} className="flex items-center gap-2.5" data-id="element-157">
                <span className="text-[#00C853] text-base flex-shrink-0" data-id="element-158">
                  ✅
                </span>
                <span className="text-[#0A0A0A] text-sm font-semibold" data-id="element-159">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 mb-6 bg-[#FAFAFA] py-3 rounded-xl border border-[#E5E5EA]" data-id="element-160">
          <span className="text-[#0A0A0A] text-xs sm:text-sm font-black uppercase tracking-wider" data-id="element-161">
            ⏰ Termina tra
          </span>
          <CountdownTimer size="sm" blinking={false} data-id="element-162" />
        </div>

        <a href={offer.ctaHref} className="btn-cta-green block w-full text-center font-black text-lg sm:text-xl py-5 rounded-2xl transition-colors shadow-lg mb-4" data-id="element-163">
          {offer.ctaText}
        </a>

        <p className="text-[#5A5A66] text-xs text-center mb-6 font-semibold" data-id="element-164">
          💱 Pagherai nella tua valuta locale
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-[#5A5A66] font-bold" data-id="element-165">
          <span className="flex items-center gap-1.5" data-id="element-166">🔒 Pagamento Sicuro</span>
          <span className="flex items-center gap-1.5" data-id="element-167">⚡ Accesso in 5 min</span>
          <span className="flex items-center gap-1.5" data-id="element-168">
            🛡️ Garanzia 7 Giorni
          </span>
          <span className="flex items-center gap-1.5" data-id="element-169">💳 Carta · PayPal</span>
        </div>
      </div>
    </section>;
}